import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ImportJobStatus } from '../attr-mapping.constants';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'vrm-status-renderer',
  template: `
    <div [ngClass]="statusClass" class="status-container">
      {{ statusText }}
    </div>
  `,
  styles: [
    `
      .status-container {
        border-radius: 3px;

        display: inline-block;
        text-align: center;
      }
      .grey {
        color: #e0e0e0;
      }
      .green {
        color: #4caf50;
      }
      .yellow {
        color: #ffeb3b;
      }
      .red {
        color: #f44336;
      }
      .blue {
        color: #336699;
      }
    `,
  ],
})
export class ImportStatusRendererComponent implements ICellRendererAngularComp {
  private params: ICellRendererParams;
  statusText: string = '';
  statusClass: string = '';

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.setStatus(params.data.jobStatus); // Assuming status is a field in your row data
  }

  refresh(): boolean {
    return false;
  }

  setStatus(status: string): void {
    const statusInfo = ImportJobStatus[status];
    if (statusInfo) {
      this.statusText = statusInfo.text;
      this.statusClass = statusInfo.class;
    } else {
      this.statusText = 'Unknown';
      this.statusClass = 'grey';
    }
  }
}
